import { render } from "./CanadianFlag.vue?vue&type=template&id=efe39a6e"
import script from "./CanadianFlag.vue?vue&type=script&lang=js"
export * from "./CanadianFlag.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__